import AppContext from '@context';
import { JourneysStateInterface } from '@context/reducers/journeys/journeys.type';
import { handleClickRateDriver } from '@helpers/companyEvaluating';
import useAmplitude from '@hooks/useAmplitude';
import React, { useContext } from 'react';
import { ActionPropsInterface } from './ActionTypes';
import SectionAction from './SectionAction';
import { SectionActionPropsInterface } from './SectionAction/SectionActionTypes';

function Action({ handlerOpenModalConfirm, innerRef }: ActionPropsInterface) {
  const {
    state: { journeys },
    dispatch,
  } = useContext(AppContext);
  const { data: journeySelection } =
    journeys.selection as JourneysStateInterface['selection'];
  const journey = journeySelection?.journey;
  const origin = journey?.address.pickup;
  const destination = journey?.address.delivery;

  const actionData: SectionActionPropsInterface = {
    title: 'A carga foi entregue?',
    action: {
      text: 'Confirmar entrega',
      onClick: () => handleFinishJourney(),
      textDispute: 'Reportar problema',
      onDispute: () => handleClickDispute(),
    },
  };
  const { amplitudeEvent } = useAmplitude();

  function handleFinishJourney() {
    if (!journey) return;

    amplitudeEvent('journey_finish_clicked', {
      source: 'finalizar-viagem-drawer',
      journey_id: journey?.id || '',
      pickup: origin?.description || '',
      delivery: destination?.description || '',
    });

    handlerOpenModalConfirm(journey.id);
  }

  function handleClickDispute() {
    dispatch({
      type: 'ui_modalMonitoring_set_show',
      payload: {
        isShow: false,
        flow: 'button',
        journeyId: journey?.id || '',
      },
    });
    handleClickRateDriver(journey?.id || '');
    amplitudeEvent('company_dispute_request', {
      source: 'modal-monitoring',
    });
  }

  function handleAddRoute() {
    amplitudeEvent('journey_address_update_clicked', {
      source: 'adicionar-rota-monitoramento-viagem',
      journey_id: journey?.id || '',
    });

    dispatch({
      type: 'ui_modalUpdatedAddress_set_show',
      payload: {
        isShow: true,
        journeyId: journey?.id || '',
      },
    });
  }

  if (
    journey?.status.label === 'done' ||
    journey?.status.label === 'canceled' ||
    journey?.status.label === 'unrecognized' ||
    journey?.status.label === 'refused'
  ) {
    return null;
  }

  if (journey?.status.label === 'pending_route') {
    delete actionData.action.textDispute;
    delete actionData.action.onDispute;

    actionData.title = 'Ative o monitoramento!';
    actionData.description = 'Adicione a origem/destino da carga';
    actionData.action = {
      text: 'Adicionar rota',
      onClick: handleAddRoute,
      icon: 'arrow-right',
    };
  }

  return <SectionAction {...actionData} innerRef={innerRef} />;
}

export default Action;
